// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Input_wrap__1N7eV","prefix":"Input_prefix__2A9BN","suffix":"Input_suffix__1kr_R","disabled":"Input_disabled__b8qIF","input":"Input_input__3rPb3"};